import React, { useEffect, useState } from "react";
import Breadcrump from "../../Components/Breadcrump";
import privacyPolicyApi from "../../api/privacyPolicyApi";
import { extractCmsDescription } from "../../utils/cmsUtils";

function PrivacyPolicy() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    fetchCMSDetails();
  }, []);

  const fetchCMSDetails = async () => {
    try {
      const res = await privacyPolicyApi.details();

      if (res.code === 200) {
        setTitle("Privacy Policy");
        setDescription(extractCmsDescription(res.data, "privacy-policy"));
      }
    } catch (err) {
      console.error("Privacy Policy API Error:", err);
    }
  };

  return (
    <>
      <Breadcrump title={"Privacy Policy"} />

      <section className="terms-condition py-5">
        <div className="container">
          <div className="content text-dark">
            {description ? (
              <div
                dangerouslySetInnerHTML={{ __html: description }}
                style={{ color: "#000", fontSize: "16px" }}
              />
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
